import { AppState } from "features";
import { getActiveLocation } from "../../location/selectors/getLocationPermissions";

export const showYumpingoOptionsFilter = () => (state: AppState) =>
    !!getActiveLocation(state)?.yumpingoOptions?.enabled;
